const STORAGE_KEY = 'ig_post_auth_redirect_v1';

/**
 * Where to send the user after login/registration instead of /dashboard.
 * sessionStorage (not router state) so it survives the full-page redirects of
 * the Google sign-in flow. Only same-origin app paths are accepted.
 */
export function setPostAuthRedirect(path: string): void {
  try {
    if (path.startsWith('/') && !path.startsWith('//')) {
      window.sessionStorage.setItem(STORAGE_KEY, path);
    }
  } catch {
    // Storage unavailable (private mode) — the user just lands on /dashboard.
  }
}

/** Returns the stored redirect path (clearing it), or the given fallback. */
export function consumePostAuthRedirect(fallback = '/dashboard'): string {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      if (stored.startsWith('/') && !stored.startsWith('//')) return stored;
    }
  } catch {
    // Ignore and fall through to the fallback.
  }
  return fallback;
}
